class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    console.log(`Closed mega menu`);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Setup redirection samo jednom
    if (!HeaderMenu.redirectionSetup) {
      this.setupMenuRedirection();
      HeaderMenu.redirectionSetup = true;
    }
  }

  setupMenuRedirection() {
    const allMenuItems = document.querySelectorAll('header-menu');
    const firstMenuItem = allMenuItems[0];
    const firstSubmenu = firstMenuItem.querySelector('.header__submenu');
    const firstDetails = firstMenuItem.querySelector('details');
    
    // Sačuvaj originalni sadržaj prvog menija
    const originalFirstContent = firstSubmenu.innerHTML;
    
    allMenuItems.forEach((menuItem, index) => {
      const summary = menuItem.querySelector('summary');
      if (summary) {
        if (index === 0) {
          // Prvi element - ponašanje kao i ostali: zatvori ostale, vrati originalni sadržaj i otvori prvi
          summary.addEventListener('click', (e) => {
            e.preventDefault();

            // Zatvori sve menuje
            allMenuItems.forEach(item => {
              const details = item.querySelector('details');
              details.removeAttribute('open');
            });

            // Vrati originalni sadržaj prvog menija i otvori ga
            firstSubmenu.innerHTML = originalFirstContent;
            firstDetails.setAttribute('open', '');
          });
          return;
        }
        
        // Ostali elementi - redirectuj na prvi
        summary.addEventListener('click', (e) => {
          e.preventDefault(); // Spreči default otvaranje
          
          // Zatvori sve menuje
          allMenuItems.forEach(item => {
            const details = item.querySelector('details');
            details.removeAttribute('open');
          });
          
          // Kopiraj sadržaj kliknutog u prvi element
          const clickedSubmenu = menuItem.querySelector('.header__submenu');
          // firstDetails je definisan iznad
          
          if (clickedSubmenu && firstSubmenu) {
            // Kopiraj ceo HTML sadržaj
            firstSubmenu.innerHTML = clickedSubmenu.innerHTML;
            
            // Otvori prvi details element
            firstDetails.setAttribute('open', '');
          }
        });
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Close mega menu on scroll
let scrollTimeout;
window.addEventListener('scroll', function() {
  // Use debouncing to improve performance
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(function() {
    const openMenus = document.querySelectorAll('header-menu details[open]');
    openMenus.forEach(function(menu) {
      const headerMenuElement = menu.closest('header-menu');
      if (headerMenuElement && headerMenuElement.close) {
        headerMenuElement.close();
      }
    });
  }, 10); // Small delay to prevent excessive calls during scroll
});

// Close mega menu when clicking outside any header-menu (desktop and general)
document.addEventListener('click', function(event) {
  // If click is inside any header-menu, do nothing
  if (event.target.closest('header-menu')) return;
  const openDetails = document.querySelectorAll('header-menu details[open]');
  if (!openDetails.length) return;
  openDetails.forEach(function(detailsEl) {
    const instance = detailsEl.closest('header-menu');
    if (instance && typeof instance.close === 'function') {
      instance.close();
    } else {
      detailsEl.removeAttribute('open');
      const summary = detailsEl.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', false);
    }
  });
});
